import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedFilms from './components/FeaturedFilms';
import CategoryPreview from './components/CategoryPreview';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '北条麻妃电影全集精选',
            url: 'https://hojomaki-film.com/',
            description: '探索北条麻妃电影完整作品列表，涵盖高清影片资源、经典代表作介绍与在线观看指南。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://hojomaki-film.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '北条麻妃电影全集精选网站是什么？', acceptedAnswer: { '@type': 'Answer', text: '这是一个专注于北条麻妃电影作品的资源导航平台，为影迷提供最全面的北条麻妃电影信息汇总。' } },
              { '@type': 'Question', name: '如何在网站上找到想要的北条麻妃电影？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的分类导航浏览不同类型的作品，也可以使用搜索功能输入作品名称快速定位。' } },
              { '@type': 'Question', name: '网站上的电影资源清晰度如何？', acceptedAnswer: { '@type': 'Answer', text: '我们收录的北条麻妃电影资源均为高清画质，大部分作品提供1080P全高清版本，最新作品更提供4K超高清版本。' } },
              { '@type': 'Question', name: '北条麻妃有哪些必看的经典代表作？', acceptedAnswer: { '@type': 'Answer', text: '北条麻妃最受影迷推崇的经典作品包括《美熟女画報》《昭和の女》《人妻の秘密》《未亡人の決意》等。' } },
              { '@type': 'Question', name: '北条麻妃的最新作品在哪里可以看到？', acceptedAnswer: { '@type': 'Answer', text: '您可以在网站的"最新作品"分类中查看北条麻妃最新上映的作品信息。' } },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://hojomaki-film.com/' },
            ],
          }),
        }}
      />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedFilms />
          <CategoryPreview />
          <LatestArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}